/** API client for the Settings → Usage tab. */
import { apiRequest } from "./client";

export interface RuntimeSegmentUsageRow {
  runtime_session_id: string;
  conversation_id: string | null;
  project_id: string;
  project_name: string;
  agent_name: string | null;
  ticket_display: string | null;
  model: string | null;
  models?: string[];
  total_input_tokens: number;
  total_output_tokens: number;
  total_cost_cents: number;
  status: "active" | "idle" | "ended" | "compacted_into";
  started_at: string;
  ended_at: string | null;
  last_heartbeat_at: string | null;
}

interface ListResponse {
  status: "success";
  data: RuntimeSegmentUsageRow[];
}

/**
 * GET /api/v1/usage/runtime-segments/
 *
 * Returns every runtime segment belonging to the current user across all
 * their projects, ordered by started_at desc.
 */
export async function listRuntimeSegmentUsage(): Promise<
  RuntimeSegmentUsageRow[]
> {
  const resp = await apiRequest<ListResponse>(
    "/api/v1/usage/runtime-segments/",
    { method: "GET" },
  );
  return resp.data;
}

export interface MonthlyRuntimeUsage {
  period_start: string;
  period_end: string;
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  total_cost_cents: number;
  basis: "runtime_segments_started_in_period";
}

export interface MonthlyRuntimeUsagePage {
  items: RuntimeSegmentUsageRow[];
  total: number;
  next_offset: number | null;
}

export async function getMonthlyRuntimeUsage(): Promise<MonthlyRuntimeUsage> {
  const response = await apiRequest<{
    status: "success";
    data: MonthlyRuntimeUsage;
  }>("/api/v1/usage/runtime-segments/summary/", {
    method: "GET",
    silent: true,
  });
  return response.data;
}

export async function listMonthlyRuntimeUsage(
  options: { offset?: number; limit?: number } = {},
): Promise<MonthlyRuntimeUsagePage> {
  const params = new URLSearchParams({
    offset: String(options.offset ?? 0),
    limit: String(options.limit ?? 20),
  });
  const response = await apiRequest<{
    status: "success";
    data: MonthlyRuntimeUsagePage;
  }>(`/api/v1/usage/runtime-segments/monthly/?${params}`, {
    method: "GET",
    silent: true,
  });
  return response.data;
}
